import type { TFunction } from 'i18next'

import { Action } from '@/graphql/generated/schemas'
import { formatFullName } from '@/utils/formats'
import { exhaustiveCheck } from '@/utils/helpers'

import type { RuleRowData } from '../types/rulesTable'
import type { RulesListType } from './utils'

export const getTranslatedActionText = (
  t: TFunction,
  action?: Action | null,
  isDryRun = false
) => {
  switch (action) {
    case Action.Mute: {
      return t('automations:action_mute')
    }
    case Action.EnableAiOperator: {
      return isDryRun
        ? t('automations:action_ai_operator_dry_run')
        : t('automations:action_ai_operator')
    }
    case Action.SendEmail: {
      return t('automations:action_email')
    }
    case Action.SetPriority: {
      return t('automations:action_set_priority')
    }
    case undefined:
    case null: {
      return ''
    }
    default:
      exhaustiveCheck(action as never)
      return ''
  }
}

export const getRuleRows = (
  rules: RulesListType,
  t: TFunction
): RuleRowData[] =>
  rules.reduce<RuleRowData[]>((rows, ruleEdge) => {
    const rule = ruleEdge?.node

    if (!rule?.id) return rows

    const createdBy = rule.creator ? formatFullName(rule.creator).trim() : ''

    rows.push({
      id: rule.id,
      isV2: !!rule.isV2,
      createdAt: rule.createdAt,
      lastMatched: rule.lastMatched,
      ruleName: rule.name ?? '',
      active: rule,
      createdBy: createdBy.length ? createdBy : null,
      action: getTranslatedActionText(
        t,
        rule.action,
        rule.aiOperatorRuleDetails?.isDryRun ?? false
      ),
    })

    return rows
  }, [])
